import { Spin } from "antd";

import FullCenterBox from "@/components/Elements/FullCenterBox";

const CenteredSpinner = (props) => (
  <FullCenterBox>
    <Spin {...props} />
  </FullCenterBox>
);

export default CenteredSpinner;
